const tur = {
    "key": "Translated Content",
    "loc_leaderboard": "Liderlik Sıralaması",
    "loc_leaderboard_info": "<span>Puan<span> Kazan, ne kadar çok puan toplarsan, iyi <span>ödüller<span> kazanma şansın olur",
    "loc_see_discount": "İndirimlere Göz At",
    "loc_turn_sound_off": "Sesi Kapat",
    "loc_turn_sound_on": "Sesi Aç",
    "loc_discount": "İndirim",
    "loc_your_discounts": "Kazanılan İndirimler",
    "loc_go_to_the_website": "Web Siteye git",
    "loc_welcome": "Hoş geldin",
    "loc_what_is_your_name": "Oyun için isim gir",
    "loc_incorect_name": "Yanlış isim",
    "loc_map_screen": "Harita Ekranı",
    "loc_go_back": "Geri Dön",
    "loc_tutorial": "Örnek video",
    "loc_next_tip": "Gelecek ipucu",
    "loc_phone_oriental": "En iyi oyun deneyimi için lütfen telefonunu çevir",
    "loc_pixi_pause": "Durdur",
    "loc_pixi_pts": "Puan",
    "loc_pixi_discount": "İndirim",
    "loc_bg_release_tutorial_1": "Aynı satırda üç özdeş olan tuğlayı topla, bitişik tuğlaları değştir",
    "loc_bg_release_tutorial_2": "Aynı satırdaki her tuğla arka planı açar, bölümü tamamlamak için arka planı temizle",
    "loc_drop_product_tutorial": "Kiremitleri aşağıya doğru toplayarak maskaraların yerlerini değiştir, bölümü tamamla",
    "loc_fill_bar_tutorial": "Tuğlaları toplayarak bölümü bitir",
    "loc_lose_popup": "Bölüm % Başarısız ",
    "loc_win_popup": "Bölüm % Tamamlandı",
    "loc_hello": "Selam",
    "loc_start_game": "Oyunu Başlat",
    "loc_logic_popup_top": "Görünüşe göre oturum açmamışsın",
    "loc_logic_popup_bottom": "Lütfen oturum aç veya hesap oluştur",
    "loc_ log_in": "Oturum aç",
    "loc_tutorial_name_fillBar": "«Boşlukları Doldur» Modu",
    "loc_tutorial_name_background_release": "«Arka planı kaldır» Modu",
    "loc_tutorial_name_drop_product": "«Ürünleri düşür» Modu",
    "loc_loading": "YÜKLENİYOR..",
    "loc_login_placeholder": "İsim",
    "loc_play": "Oyun",
    "loc_level": "Level",
    "loc_create_account": "HESAP OLUŞTUR",
    "loc_please_log_in": "OTURUM AÇ YAP VEYA",
    "loc_done": "BİTTİ",
    "loc_try_again": "TEKRAR DENE",
    "loc_you_win": "KAZANDIN!",
    "loc_login": "OTURUM AÇ",
    "loc_login_info": "Görünüşe göre oturum açmamışsın",
    "loc_oops": "OPPS!",
    "loc_resume": 'DEVAM ET',
};
export default tur;
